import { render } from "./CurrentAssetParticulars.vue?vue&type=template&id=01b26a77&scoped=true"
import script from "./CurrentAssetParticulars.vue?vue&type=script&lang=js"
export * from "./CurrentAssetParticulars.vue?vue&type=script&lang=js"

import "./CurrentAssetParticulars.vue?vue&type=style&index=0&id=01b26a77&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01b26a77"]])

export default __exports__